import styled from 'styled-components';

export const UserInterfaceFormStyled = styled.div`
  .body_form_user {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .input_warp {
      display: flex;
      width: 100%;
      &.mt30 {
        margin-top: 30px;
      }
      /* หัวข้อกลุ่ม Native bar: แถวหัวข้อเบา ๆ มีเส้นคั่นด้านบน และ chip เล็ก ๆ บอกคอลัมน์ Click / Unclick */
      &.native_section {
        margin-top: 30px;
        padding: 18px 0 4px;
        border-top: 1px solid ${({ theme }) => theme.COLORS.GRAY_4};
        align-items: center;
        .left_box {
          flex-direction: column;
          align-items: flex-start;
          row-gap: 2px;
          .ns_title {
            font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
            font-size: ${({ theme }) => theme.FONT.SIZE.S16};
            color: ${({ theme }) => theme.COLORS.BLUE_7};
          }
          .ns_desc {
            font-size: ${({ theme }) => theme.FONT.SIZE.S12};
            color: ${({ theme }) => theme.COLORS.BLUE_2};
          }
        }
        .right_box {
          align-items: center;
          .ns_chip {
            display: inline-flex;
            align-items: center;
            column-gap: 8px;
            padding: 6px 12px;
            border-radius: 999px;
            background: ${({ theme }) => theme.COLORS.BLUE_5};
            border: 1px solid ${({ theme }) => theme.COLORS.GRAY_4};
            font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
            font-size: ${({ theme }) => theme.FONT.SIZE.S14};
            color: ${({ theme }) => theme.COLORS.BLUE_7};
            small {
              font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
              font-size: ${({ theme }) => theme.FONT.SIZE.S12};
              color: ${({ theme }) => theme.COLORS.BLUE_2};
            }
            .ns_dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              flex-shrink: 0;
            }
            &.click .ns_dot {
              background: ${({ theme }) => theme.COLORS.BLUE_4};
            }
            &.unclick .ns_dot {
              background: ${({ theme }) => theme.COLORS.GRAY_7};
            }
          }
        }
      }
      .left_box {
        width: 20%;
        display: flex;
        align-items: center;
      }
      .right_box {
        width: 80%;
        display: flex;
        align-items: flex-start;
        .box1 {
          width: 48%;
          &.bg {
            background: #babab8;
          }
        }
        .box2 {
          width: 48%;
          padding-left: 10px;
          &.bg {
            background: #ebebe9;
          }
        }
        .w50 {
          width: 50%;
        }
      }
    }
    .btn_zone {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
      .w120 {
        width: 120px;
      }
    }
  }
  .phone_layout {
    position: relative;
    margin: auto;
    width: 492px;
    .phone_body_container {
      border-radius: 1rem;
      position: absolute;
      top: 16px;
      left: 0px;
      right: 0px;
      margin: auto;
      width: 312px;
      overflow: hidden;
      height: calc(100% - 83px);
      .p_header {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 123px;
        background-color: ${({ theme }) => theme.COLORS.BLUE_1};
        background-image: url(/assets/images/bg/bg.png);
        background-position: center;
        background-size: cover;
        z-index: 3;
        .header_row {
          height: 100%;
          display: flex;
          justify-content: space-betweeen;
          align-items: center;
          .header_left_col {
            flex: 1;
            height: calc(100% - 30px);
            overflow: hidden;
            padding: 15px;
            .nav_logo_wrap {
              margin: auto;
              width: 100%;
              height: auto;
              .nav_logo {
                width: 100%;
                height: auto;
              }
            }
          }
          .header_right_col {
            flex-shrink: 0;
            flex-basis: 140px;
            .nav_point {
              margin-bottom: -24px;
              border-radius: 107px;
              border: 4px solid ${({ theme }) => theme.COLORS.WHITE_1};
              position: relative;
              width: 107px;
              height: 107px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #facc00;
              color: ${({ theme }) => theme.COLORS.BLACK_1};
              font-size: ${({ theme }) => theme.FONT.SIZE.S35};
              font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
              .nav_p_label {
                position: absolute;
                top: -8px;
                right: -18px;
                width: 80px;
                height: 25px;
                background-image: url(/assets/images/icons/point.png);
                background-size: contain;
                background-repeat: no-repeat;
                display: flex;
                justify-content: center;
                align-items: center;
                .nav_point_label {
                  color: ${({ theme }) => theme.COLORS.WHITE_1};
                  font-size: ${({ theme }) => theme.FONT.SIZE.S10};
                  font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
                }
              }
              .coin_img {
                position: absolute;
                bottom: 0px;
                right: -20px;
                width: 34px;
                height: auto;
              }
            }
          }
        }
      }
      .p_body {
        position: absolute;
        top: 123px;
        height: 475px;
        width: 100%;
        background-color: ${({ theme }) => theme.COLORS.BLUE_1};
        background-position: center;
        background-size: cover;
        background-image: url(/assets/images/bg/bg-white.jpg);
      }
      .p_menu_bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 75px;
        display: flex;
        background: #095098;
        background-position: center;
        background-size: cover;
        .menu_wrap {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &.active {
            .menu_item {
              .mi_label {
                color: ${({ theme }) => theme.COLORS.ORANGE_1};
              }
            }
          }
          .menu_item {
            padding-top: 6px;
            .menu_img_figture {
              margin: auto;
              width: 36px;
              height: 36px;
              .menu_img {
                width: 36px;
                height: 36px;
                object-fit: cover;
              }
            }
            .mi_label {
              margin-top: 6px;
              text-align: center;
              color: ${({ theme }) => theme.COLORS.WHITE_1};
              font-size: ${({ theme }) => theme.FONT.SIZE.S14};
              font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
            }
          }
        }
      }
    }
  }
`;
